import { FC } from 'react';
import { CloseIcon } from 'Components';
import { IconButton } from '@material-ui/core';

import './DialogCloseComponent.scss';

type DialogCloseProps = {
  closeFunction: any;
};

const DialogCloseComponent: FC<DialogCloseProps> = ({ closeFunction }) => {
  return (
    <IconButton onClick={closeFunction} aria-label="Kapat" size="small" className="dialogCloseButton">
      <CloseIcon style={{ position: 'static' }} />
    </IconButton>
  );
};

export default DialogCloseComponent;
